// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_105329b597--wrapper--tI2kg","link":"_105329b597--link--zMKRM"};